import { graphql, type DocumentType } from '@/graphql';

const _chatContextFragment = graphql(/* GraphQL */ `
  fragment NewChatContext on ChatContext {
    id
    kind
    portfolioId
    benchmarkId
    start
    end
    currency
    assetids
  }
`);

export type ChatContextFragment = DocumentType<typeof _chatContextFragment>;

const _chatPromptFragment = graphql(/* GraphQL */ `
  fragment NewChatPrompt on ChatPrompt {
    id
    chatId
    contexts {
      ...NewChatContext
    }
    dateCreated
    prompt
    response
    promptTokenCount
    responseTokenCount
    duration
    feedback
  }
`);

export type ChatPromptFragment = DocumentType<typeof _chatPromptFragment>;

const _chatFragment = graphql(/* GraphQL */ `
  fragment NewChat on Chat {
    id
    name
    dateCreated
    dateUpdated
    version
    contexts {
      ...NewChatContext
    }
  }
`);
export type ChatFragment = DocumentType<typeof _chatFragment>;

const _chatWithPromptsFragment = graphql(/* GraphQL */ `
  fragment NewChatWithPrompts on Chat {
    ...NewChat
    prompts {
      ...NewChatPrompt
    }
  }
`);
export type ChatWithPromptsFragment = DocumentType<typeof _chatWithPromptsFragment>;

export const chatListQuery = graphql(/* GraphQL */ `
  query ChatList($input: ChatsListInput!) {
    chats(input: $input) {
      id
      data {
        ...NewChat
      }
    }
  }
`);

export const chatQuery = graphql(/* GraphQL */ `
  query Chat($id: ID!) {
    chat(id: $id) {
      ...NewChatWithPrompts
    }
  }
`);

export const updateChatMutation = graphql(/* GraphQL */ `
  mutation UpdateChat($input: UpdateChatInput!) {
    updateChat(input: $input) {
      ...NewChat
    }
  }
`);

export const deleteChatMutation = graphql(/* GraphQL */ `
  mutation DeleteChat($id: ID!) {
    deleteChat(id: $id)
  }
`);

export const createChatPromptMutation = graphql(/* GraphQL */ `
  mutation NewChatPrompt($input: ChatPromptInput!) {
    chatPrompt(input: $input) {
      ...NewChatPrompt
    }
  }
`);

export const createChatMutation = graphql(/* GraphQL */ `
  mutation NewCreateChat($input: CreateChatInput!) {
    createChat(input: $input) {
      ...NewChatWithPrompts
    }
  }
`);

export const promptFeedbackMutation = graphql(/* GraphQL */ `
  mutation NewPromptFeedback($input: ChatPromptFeedbackInput!) {
    chatPromptFeedback(input: $input)
  }
`);
